import React from 'react';
import c from 'classnames';
import CommentBoxContentWrapper from '../../lego/CommentBoxContentWrapper';
import s from './CommentBoxLayout.scss';

interface Props {
  /** A slot that displays above our `content` */
  above?: React.ReactNode;

  /** Small area to the left of our `content`. */
  avatar?: React.ReactNode;

  /** The main content of the layout. */
  content: React.ReactNode;

  className?: string;
}

/**
 * Our comment box's layout.
 */
const CommentBoxLayout = React.forwardRef<HTMLDivElement, Props>(
  ({ above, avatar, content, className }, ref) => {
    return (
      <div className={c(s['root'], className)} ref={ref}>
        {above && <div className={s['above']}>{above}</div>}
        <div className={s['main']}>
          {avatar && <div className={s['avatar']}>{avatar}</div>}
          <CommentBoxContentWrapper className={s['content']}>
            {content}
          </CommentBoxContentWrapper>
        </div>
      </div>
    );
  }
);
CommentBoxLayout.displayName = 'CommentBoxLayout';

export default CommentBoxLayout;
